import { render, staticRenderFns } from "./ResetPwd.vue?vue&type=template&id=5d148104&scoped=true"
import script from "./ResetPwd.vue?vue&type=script&lang=js"
export * from "./ResetPwd.vue?vue&type=script&lang=js"
import style0 from "./ResetPwd.vue?vue&type=style&index=0&id=5d148104&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d148104",
  null
  
)

export default component.exports